import request from "../../../util/request"
import { APP_KEY, PHP_API_URL } from "../../../util/constants";
import Cookies from 'js-cookie'
export function getAliOssTokenRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('utoken', Cookies.get("userToken"));
    return request(PHP_API_URL+"/aliyun/osssts.php", {
        method: "POST",
        body: formData
    }, callback);
}
export function getUserInfoRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', "get_school_teacher_info");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('username', Cookies.get("username"));
    return request(PHP_API_URL+"/User/i", {
        method: "POST",
        body: formData
    }, callback);
}

export function updateTeacherUserInfoRequest(image_url,name,pwd,identityInfoJson, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo', "school_teacher_update_info");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('username', Cookies.get("username"));
    formData.append('image_url', image_url==null ||image_url=="null" || image_url == "" ? "" : image_url);
    formData.append('name', name);
    formData.append('pwd', pwd);
    formData.append('school_code', Cookies.get("school_code"));
    formData.append('school_teacher_shenfen_json', identityInfoJson);
    return request(PHP_API_URL+"/User/i", {
        method: "POST",
        body: formData
    }, callback);
}